import {useTranslation} from 'react-i18next'

type Props = {
 isOpen: boolean
 onClose: () => void
 remark: string
 setRemark: (val: string) => void
 onSubmit: () => void
}

const ReopenTicketModal = ({
 isOpen,
 onClose,
 remark,
 setRemark,
 onSubmit,
}: Props) => {
 const {t} = useTranslation()
 if (!isOpen) return null

 const isValid = remark.trim().length > 0

 return (
  <div className='fixed inset-0 z-50 flex items-center justify-center'>
   <div
    className='absolute inset-0 bg-black/60'
    onClick={onClose}
   />

   <div className='relative w-[640px] rounded-[24px] bg-white px-8 py-7 shadow-2xl'>
    <div className='mb-6 flex items-center justify-between'>
     <h2 className='text-[22px] font-semibold text-gray-900'>
      {t('ticket.reopenTicket.title')}
     </h2>

     <button
      onClick={onClose}
      className='flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-xl text-gray-700 hover:bg-gray-200'
     >
      ✕
     </button>
    </div>

    <div className='relative mb-8'>
     <textarea
      value={remark}
      onChange={(e) => setRemark(e.target.value)}
      placeholder='Enter remark'
      className='peer h-[170px] w-full resize-none rounded-xl border border-gray-200 bg-white px-4 pt-6 pb-3 text-sm text-gray-800 outline-none transition focus:border-blue-500 mt-2'
     />

     <label className='absolute left-4 top-2 text-sm text-[#4E83E4]'>
      {t('ticket.reopenTicket.subtitle')}
      <span className='text-red-500'>*</span>
     </label>
    </div>

    <button
     onClick={() => {
      if (isValid) onSubmit()
     }}
     // disabled={!isValid}
     className={`w-full rounded-xl py-4 text-sm font-semibold transition
            ${
             isValid
              ? 'bg-blue-600 text-white hover:bg-[#4E83E4]'
              : 'bg-gray-100 text-gray-400 cursor-not-allowed'
            }
          `}
    >
     {t('ticket.reopenTicket.button')}
    </button>
   </div>
  </div>
 )
}

export default ReopenTicketModal
